import React, { useEffect, useState } from 'react'
import Head from '../../layout/head/Head'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  Button,
  Typography,
  Box,
  Card,
  CardContent
} from '@mui/material'
import { Icon } from '../../components/Component'
import { PaymentServices } from '../../services/McDataServices'

const PaymentResult = ({ userRoles }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [result, setResult] = useState({})

  useEffect(() => {
    const fetchPaymentResult = async () => {
      const requestId = searchParams.get('requestId')
      if (requestId) {
        try {
          const response = await PaymentServices.PaymentStatus(requestId)
          setResult(response)
        } catch (error) {
          console.error('Error fetching payment result:', error)
        }
      }
    }
    fetchPaymentResult()
  }, [searchParams])

  const stateConfig = {
    ACCEPTED: {
      icon: 'check-circle-cut',
      color: '#6fbc8f',
      message: t('payment.accepted')
    },
    REQUESTED: {
      icon: 'clock-fill',
      color: '#f7d776',
      message: t('payment.requested')
    },
    REJECTED: {
      icon: 'cross-circle-fill',
      color: '#e57274',
      message: t('payment.rejected')
    }
  }

  const currentState = stateConfig[result.state] || stateConfig.REJECTED

  return (
    <>
      <Head title={t('payment.header')} />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: 500
        }}
      >
        <Card
          style={{
            width: '100%',
            maxWidth: 400,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            borderRadius: '12px'
          }}
        >
          <CardContent
            style={{
              padding: '2rem 3rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '.8rem'
            }}
          >
            <Icon
              name={currentState.icon}
              style={{
                color: currentState.color,
                fontSize: '6rem'
              }}
            />
            <Typography variant="h4" fontWeight="bold">
              {t('payment.result')}
            </Typography>
            <Typography variant="h6" fontWeight="medium" textAlign="center">
              {currentState.message}
            </Typography>
            {result.state !== 'ACCEPTED'
              ? <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              borderTop={'1px solid var(--mui-palette-divider)'}
              width={'100%'}
              mt={6}
              pt={2}
            >
              <Typography
                variant="body2"
                color="textSecondary"
              >
                {`${t('payment.requestId')}: ${searchParams.get('requestId')}`}
              </Typography>
              {result?.paymentSystemResponse?.code &&
                <Typography
                  variant="body2"
                  color="textSecondary"
                >
                  {`${t('payment.errorCode')}: ${result.paymentSystemResponse.code}`}
                </Typography>
              }
              {result?.paymentSystemResponse?.message &&
                <Typography
                  variant="body2"
                  color="textSecondary"
                >
                  {`${t('payment.errorMessage')}: ${result.paymentSystemResponse.message}`}
                </Typography>
              }
            </Box>
              : '' }
            <Box textAlign="center" mt={6}>
              <Button
                size="medium"
                variant="outlined"
                color="primary"
                startIcon={<Icon name="arrow-left-circle-fill" />}
                onClick={() => navigate('/')}
              >
                {t('menu.dashboard')}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default PaymentResult
